import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomFieldDefinition, CustomFieldOwnerType } from 'src/app/custom-fields/custom-fields.model';
import { CustomFieldsService } from 'src/app/custom-fields/custom-fields.service';
import { Choice } from 'src/app/shared/components/select/choice.model';

@Component({
  selector: 'app-select-audience-custom-fields-to-export',
  templateUrl: './select-audience-custom-fields-to-export.component.html',
  styleUrls: ['./select-audience-custom-fields-to-export.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SelectAudienceCustomFieldsToExportComponent {
  customFields: Choice[] = [];
  customFieldsMap: Map<number, CustomFieldDefinition> = new Map();

  form = this.formBuilder.group({
    customFields: [[]],
  });
  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SelectAudienceCustomFieldsToExportComponent>,
    customFieldsService: CustomFieldsService
  ) {
    customFieldsService.getFields().subscribe({
      next: response => {
        this.customFields = response
          .filter(({ scope }) => scope === CustomFieldOwnerType.User)
          .map(({ id, label }) => ({ id, label }));
        response.forEach(item => this.customFieldsMap.set(item.id, item));
      },
    });
  }

  submit() {
    const result = this.form.getRawValue();
    result.customFields = result.customFields.map((id: number) => this.customFieldsMap.get(id));
    this.dialogRef.close(result.customFields);
  }
}
